import { apiGet } from '@/api/api.ts'

export interface IGetCurrentSettingData {
    safeZoneRadiusM: number
    isAppPush: boolean
    contact: string
    address: string
    latitude: number
    longitude: number
    dataIntervalMinute: number
}

export interface IGetCurrentSettingResponse {
    code: number
    message: string
    data?: IGetCurrentSettingData
}

export const apiGetCurrentSetting = async (): Promise<IGetCurrentSettingResponse> => {
    const response = await apiGet<IGetCurrentSettingData>('/app/auth/setting')
    return {
        code: Number(response.code) || 200,
        message: String(response.message) || 'success',
        data: response.data
    }
}